<template>
  <div class="component-paragraph">
    <div class="customizedTextWrapper" v-if="ready">
      <p v-markdown="replaceVar(attributes.value)" />
      <!-- <p>
        The coronavirus has infected at least
        <span class="confirmed">{{numconfirmed | formatNumber}}</span>
        and
        <span class="deaths">{{numdeaths | formatNumber}}</span>
        have died.
      </p>
      <p>
        Almost all the cases are on mainland China, centralised in Hubei province where Wuhan is located. There are at least
        <span class="confirmed">{{numhubeiconfirmed | formatNumber}}</span>
        confirmed cases in Hubei and
        <span class="deaths">{{numhubeideaths | formatNumber}}</span>
        deaths.
      </p>
      <p>
        However, on a positive note, at least
        <span class="recovered">{{numrecovered | formatNumber}}</span>
        cases have recovered worldwide.
      </p> -->
    </div>
  </div>
</template>

<script>
import {store} from './wuhanData'

export default {
  props: ['attributes'],
  computed: {
    ready () {
      return store.rawData != null
    },
    numconfirmed () {
      return store.rawData.reduce((sum, row) => sum + (row.country ? row.cases : 0), 0)
    },
    numdeaths () {
      return store.rawData.reduce((sum, row) => sum + (row.country ? row.deaths : 0), 0)
    },
    numrecovered () {
      return store.rawData.reduce((sum, row) => sum + (row.country ? row.recovered : 0), 0)
    },
    numhubeiconfirmed () {
      return store.rawData.find(row => row.province === 'Hubei').cases
    },
    numhubeideaths () {
      return store.rawData.find(row => row.province === 'Hubei').deaths
    }
  },
  filters: {
    formatNumber (n) {
      return n.toLocaleString()
    }
  },
  methods: {
    replaceVar (str = '', data = {}) {
      const reg = /\{\{(.*?)\}\}/
      var found = reg.exec(str)
      const computedVar = this._computedWatchers
      while (found) {
        var varArr = found[1].split(':')
        var val = ''
        var numberKey = varArr[0]
        if (varArr[0] in data) {
          val = data[varArr[0]].toLocaleString()
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            val += +data[numberKey] > 1 ? varArr[2] : varArr[1]
          }
          str = str.replace(found[0], val)
        } else if (varArr[0] in computedVar) {
          // if no data is provided, look in the computed variableData
          val = this[varArr[0]].toLocaleString()
          if (varArr[0].includes('num') && varArr.length > 2) {
            numberKey = numberKey.replace('ctr', '').replace('word', '') + 'ctr'
            val += +this[numberKey] > 1 ? varArr[2] : varArr[1]
          }
          str = str.replace(found[0], val)
        } else {
          str = str.replace(found[0], '')
        }
        found = reg.exec(str)
      }
      return str
    }
  }
}
</script>
<style lang="scss">
.component.component-customizedtext {
  padding: 0;
}
.customizedTextWrapper{
    p {
        padding-top: 17px;
        padding-bottom: 17px;
    }
    span {
      color: white;
      -moz-border-radius:4px 4px 4px 4px;
      border-radius:4px 4px 4px 4px;
      padding: 2px 6px;
    }
    .confirmed {
      background-color: #e18425;
    }
    .deaths {
      background-color: #952370;
    }
    .recovered {
      background-color: #02c7bf;
    }
}
</style>
